<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>{{ $t('goldBusinessManage.queryConditions') }}</h5>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="ibox-content">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="goldBusinessManageInfo.conditions.busiId"
                :placeholder="$t('goldBusinessManage.inputTransactionId')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-input
                v-model="goldBusinessManageInfo.conditions.amount"
                :placeholder="$t('goldBusinessManage.inputGoldAmount')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-input
                v-model="goldBusinessManageInfo.conditions.buyerName"
                :placeholder="$t('goldBusinessManage.inputBuyerName')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="_querygoldBusinessMethod">
              <i class="el-icon-search"></i> {{ $t('goldBusinessManage.query') }}
            </el-button>
            <el-button type="primary" size="small" @click="_resetgoldBusinessMethod">
              <i class="el-icon-refresh"></i> {{ $t('goldBusinessManage.reset') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-title">
        <h5>{{ $t('goldBusinessManage.purchaseRecords') }}</h5>
        <div class="ibox-tools" style="top:10px;"></div>
      </div>
      <div class="ibox-content">
        <el-table
          :data="goldBusinessManageInfo.goldBusinesss"
          border
          style="width: 100%"
        >
          <el-table-column prop="busiId" :label="$t('goldBusinessManage.transactionId')" align="center" />
          <el-table-column prop="busiTypeName" :label="$t('goldBusinessManage.type')" align="center" />
          <el-table-column prop="amount" :label="$t('goldBusinessManage.amount')" align="center" />
          <el-table-column prop="goldCount" :label="$t('goldBusinessManage.goldCount')" align="center" />
          <el-table-column prop="goldTypeName" :label="$t('goldBusinessManage.goldType')" align="center" />
          <el-table-column prop="createTime" :label="$t('goldBusinessManage.transactionTime')" align="center" />
          <el-table-column prop="buyerName" :label="$t('goldBusinessManage.buyer')" align="center" />
          <el-table-column prop="remark" :label="$t('goldBusinessManage.remark')" align="center" />
        </el-table>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="goldBusinessManageInfo.conditions.page"
          :page-size="goldBusinessManageInfo.conditions.row"
          layout="total, prev, pager, next"
          :total="goldBusinessManageInfo.total"
          style="margin-top: 20px; text-align: right;"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { queryGoldBusiness } from '@/api/goods/goldBusinessManage/goldBusinessManageApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GoldBusinessManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      goldBusinessManageInfo: {
        goldBusinesss: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          amount: '',
          busiId: '',
          buyerName: '',
          state: '',
          shopId: '',
          communityName: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.shopId = getShopId()
    this.goldBusinessManageInfo.conditions.shopId = this.shopId
    console.log(this.goldBusinessManageInfo.moreCondition)
    this._listgoldBusinesss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listgoldBusinesss(val, this.DEFAULT_ROWS)
    },
    async _listgoldBusinesss(_page, _rows) {
      this.goldBusinessManageInfo.conditions.page = _page
      this.goldBusinessManageInfo.conditions.row = _rows
      
      try {
        const res = await queryGoldBusiness(this.goldBusinessManageInfo.conditions)
        this.goldBusinessManageInfo.total = res.total
        this.goldBusinessManageInfo.records = res.records
        this.goldBusinessManageInfo.goldBusinesss = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _querygoldBusinessMethod() {
      this._listgoldBusinesss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetgoldBusinessMethod() {
      this.goldBusinessManageInfo.conditions.busiId = ''
      this.goldBusinessManageInfo.conditions.amount = ''
      this.goldBusinessManageInfo.conditions.buyerName = ''
      this._listgoldBusinesss(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  padding: 15px 20px 20px 20px;
}
</style>